import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import { useLanguage } from '../contexts/LanguageContext';

const SupportPage = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <h1>{t('supportTitle') || 'Support & Contact'}</h1>
        <p>{t('supportIntro') || 'Need help? Contact us below or email us anytime.'}</p>
      </header>
      <main className="landing-main" style={{ textAlign: isRTL ? 'right' : 'left', maxWidth: '600px', margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '40vh', justifyContent: 'center' }}>
        <section style={{ textAlign: 'center' }}>
          <h2>{t('contactUs') || 'Contact Us'}</h2>
          <p>
            {t('supportEmailLabel')} <a href="mailto:trysafacards@gmail.com">trysafacards@gmail.com</a>
          </p>
          <p>
            {t('supportPhoneLabel')} <a href="tel:+16179420829">(617) 942-0829</a>
          </p>
        </section>
        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <Link to="/home" className="btn btn-primary">{t('backToHome')}</Link>
        </div>
      </main>
      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default SupportPage; 